
import { Component, Prop, mixins } from "nuxt-property-decorator"
import { CORE_COVER, DEFAULT_HERO, YOAST_SEO_BREADCRUMBS, BREADCRUMBS } from "~/constants/blocks"
import Blocks from "~/mixins/blocks"
import ImageUrlS3 from "~/mixins/imageUrlS3"
import { CATEGORY_V4_ID_FURNITURE, CATEGORY_V4_ID_HOUSE_MOVE } from "~/constants/category"

@Component
export default class PageLayoutDefault extends mixins(Blocks, ImageUrlS3) {
  @Prop({ required: true }) page: Record<string, any>

  pageHero: Record<string, any> = { type: DEFAULT_HERO }
  breadcrumbs: Record<string, any> = { tagName: "div" }
  blocks: Array<Record<string, any>> = []
  YOAST_SEO_BREADCRUMBS: string = YOAST_SEO_BREADCRUMBS
  categoryId: number | null = null

  created() {
    this.categoryId = this.page?.locationForm ? this.page?.locationForm?.categoryId : null
    this.blocks = [...this.page?.blocks]

    if (this.heroCondition) {
      this.pageHero = this.blocks.shift() as Record<string, any>
    }

    if (
      this.blocks.length &&
      (this.checkForOldBreadcrumbs(this.blocks[0]) || this.checkForNewBreadcrumbs(this.blocks[0]))
    ) {
      this.breadcrumbs = this.blocks.shift() as Record<string, any>
    }
  }

  get heroCondition(): boolean {
    if (!this.blocks.length) {
      return false
    }

    return this.heroClassCondition(this.blocks[0])
  }

  get isDefaultPageHero(): boolean {
    return this.pageHero.type === DEFAULT_HERO
  }

  heroClassCondition(hero: Record<string, any>) {
    return (
      hero.type === CORE_COVER ||
      (typeof hero.attributes !== "undefined" &&
        (this.Blocks_patternCheck(hero.attributes, "hero-old-style") ||
          this.Blocks_patternCheck(hero.attributes, "header-location-form") ||
          this.Blocks_patternCheck(hero.attributes, "header-location-and-property-form") ||
          this.Blocks_patternCheck(hero.attributes, "header-location-and-property-new-form")))
    )
  }

  heroOldStyleCondition(hero: Record<string, any>) {
    return (
      typeof hero.attributes !== "undefined" &&
      this.Blocks_patternCheck(hero.attributes, "hero-old-style")
    )
  }

  locationFormCondition(hero: Record<string, any>, categoryId: number | null) {
    return (
      typeof hero.attributes !== "undefined" &&
      this.Blocks_patternCheck(hero.attributes, "header-location-form") &&
      categoryId === CATEGORY_V4_ID_FURNITURE
    )
  }

  locationAndPropertyFormCondition(hero: Record<string, any>, categoryId: number | null) {
    return (
      typeof hero.attributes !== "undefined" &&
      ((this.Blocks_patternCheck(hero.attributes, "header-location-form") &&
        categoryId === CATEGORY_V4_ID_HOUSE_MOVE) ||
        this.Blocks_patternCheck(hero.attributes, "header-location-and-property-form"))
    )
  }

  locationAndPropertyFormConditionNew(hero: Record<string, any>, categoryId: number | null) {
    return (
      typeof hero.attributes !== "undefined" &&
      this.Blocks_patternCheck(hero.attributes, "header-location-and-property-new-form")
    )
  }

  checkForNewBreadcrumbs(block: Record<string, any>): boolean {
    return this.Blocks_patternCheck(block.attributes, BREADCRUMBS)
  }

  checkForOldBreadcrumbs(block: Record<string, any>): boolean {
    return block.type === YOAST_SEO_BREADCRUMBS
  }
}
